export const useIsWebGLStudio = () => {
  return window.location.href.includes("designer");
};
